import router from "@/router/index";
import HTTP from "@/assistant/HTTP";
import Url from "@/assistant/UrlPath";
export default {
  namespaced: true,
  state: () => ({
    navNo: null,
    firstEntry: true,
    isShowNavStatus: null,
    sessionRoute: "mySession",
    subNavNo: 0,
    detailsTabIndex: 0,
    tStatus: 10800000,
    user: {},
    voucherData: {},
    planTansaction: {},
    buyResult: {},
    buyPackagesResult: {},
    organSelectForBuyPelan: "",
    allPlans: {},
    allPackage: {},
    organization: {},
    register: {},
    packagesPlansList: {},
    sessionForRecord: {},
    guestCodeStatus: {},
    sessionPhotoDeleteStatus: {},
    deleteRecordSessionStatus: {},
    changeMobile: {},
    userStatus: {},
    allUserOrg: {},
    directEntryStatus: {},
    userprofile: {},
    isLoginWithPass: false,
    setDirectEntryStatus: "",
    forgotStatus: {},
    groupEdited: {},
    newInvoiceData: {},
    financeCategoriesData: {},
    meetGroupEdited: {},
    changeTitleStatus: {},
    changeMeetGroupTitleStatus: {},
    deleteUserFromGroupStatus: {},
    deleteUserGroupStatus: {},
    allOrganList: {},
    allParentOrganList: {},
    addNewGroupStatus: {},
    financeData: {},
    paymentList: {},
    organCreditList: {},
    addUserSingleStatus: {},
    addUserWithExcelStatus: {},
    userNewGroupStatus: {},
    addNewOrganStatus: {},
    editOrganStatus: {},
    deleteOrganStatus: {},
    setOrganUserStatus: {},
    getReportsStatus: {},
    getSansRecordsStatus: {},
    setRecordingPolicyStatus: {},
    setDiscountStatus: {},
    allMyUser: {},
    allUserGroup: {},
    allGroupUser: {},
    allGroupMeet: {},
    getAllSessionData: {},
    allInvitedSession: {},
    deleteSessionStatus: {},
    allSessionGroups: {},
    setSessionGroupStatus: {},
    sessionStep1Data: {},
    sessionStep3Data: {},
    buyPlaneStatus: {},
    sessionStep2Data: {
      users: [],
      guest: false,
    },
    allRole: {},
    plansOrder: {},
    allTec: {},
    allType: {},
    allStatus: {},
    excelUser: {},
    setSissionStatus: {},
    createSessionStatus: {},
    sessionInfo: {},
    addUserSingleSessionStatus: {},
    addUserGroupSessionStatus: {},
    onlinePaymentStatus: {},
    paymentBillStatus: {},
    addSpecialSupportStatus: {},
    sessionUsers: {},
    addUserWithExcelSessionStatus: {},
    editUserInSessionStatus: {},
    deleteUserOfSessionStatus: {},
    sessionNotifications: {},
    specialSupportData: {},
    deletespecialSupportStatus: {},
    deleteSessionNotificationStatus: {},
    allSans: {},
    allSansRecordStatus: {},
    allSansRecord: [],
    addSansInSessionStatus: {},
    editSansInSessionStatus: {},
    deleteSessionSansStatus: {},
    getAllSansSubjectStatus: {},
    addNoticeForSansStatus: {},
    guestEnterStatus: {},
    userEnterStatus: {},
    userProfileData: {},
    editUserProfileStatus: {},
    editSessionStatus: {},
    audienceEntryData: {},
    allMeetGroup: {},
    deleteMeetGroupStatus: {},
    addNewMeetGroupStatus: {},
    profileChart: {},
    checkUrlStatus: {},
    allActiveSans: {},
    sansRecords: {},
    sansUser: {},
    userGroups: {},
    verificationStatus: null,
    tabStatus: 1,
    setIsGroupMeets: false,
    appTitle: "جلسات من",
  }),
  mutations: {
    exit(state) {
      state.navNo = null;
      state.firstEntry = true;
      state.isShowNavStatus = null;
      state.subNavNo = 0;
      state.detailsTabIndex = 0;
      state.tStatus = 10800000;
      state.user = {};
      state.voucherData = {};
      state.planTansaction = {};
      state.buyResult = {};
      state.buyPackagesResult = {};
      state.organSelectForBuyPelan = "";
      state.allPlans = {};
      state.allPackage = {};
      state.sessionForRecord = {};
      state.guestCodeStatus = {};
      state.sessionPhotoDeleteStatus = {};
      state.deleteRecordSessionStatus = {};
      state.organization = {};
      state.register = {};
      state.packagesPlansList = {};
      state.changeMobile = {};
      state.userStatus = {};
      state.directEntryStatus = {};
      state.userprofile = {};
      state.isLoginWithPass = false;
      state.setDirectEntryStatus = "";
      state.forgotStatus = {};
      state.allUserOrg = {};
      state.groupEdited = {};
      state.newInvoiceData = {};
      state.userNewGroupStatus = {};
      state.addNewOrganStatus = {};
      state.editOrganStatus = {};
      state.deleteOrganStatus = {};
      state.setOrganUserStatus = {};
      state.getReportsStatus = {};
      state.getSansRecordsStatus = {};
      state.setRecordingPolicyStatus = {};
      state.setDiscountStatus = {};
      state.meetGroupEdited = {};
      state.changeTitleStatus = {};
      state.changeMeetGroupTitleStatus = {};
      state.deleteUserFromGroupStatus = {};
      state.deleteUserGroupStatus = {};
      state.allOrganList = {};
      state.allParentOrganList = {};
      state.addNewGroupStatus = {};
      state.addUserSingleStatus = {};
      state.addUserWithExcelStatus = {};
      state.allMyUser = {};
      state.allUserGroup = {};
      state.allGroupUser = {};
      state.allGroupMeet = {};
      state.getAllSessionData = {};
      state.allInvitedSession = {};
      state.deleteSessionStatus = {};
      state.allSessionGroups = {};
      state.setSessionGroupStatus = {};
      state.sessionStep1Data = {};
      state.sessionStep3Data = {};
      state.sessionStep2Data = {
        users: [],
        guest: false,
      };
      state.allRole = {};
      state.plansOrder = {};
      state.allTec = {};
      state.allType = {};
      state.allStatus = {};
      state.excelUser = {};
      state.setSissionStatus = {};
      state.createSessionStatus = {};
      state.sessionInfo = {};
      state.addUserSingleSessionStatus = {};
      state.addUserGroupSessionStatus = {};
      state.onlinePaymentStatus = {};
      state.paymentBillStatus = {};
      state.addSpecialSupportStatus = {};
      state.sessionUsers = {};
      state.addUserWithExcelSessionStatus = {};
      state.editUserInSessionStatus = {};
      state.deleteUserOfSessionStatus = {};
      state.sessionNotifications = {};
      state.specialSupportData = {};
      state.deletespecialSupportStatus = {};
      state.deleteSessionNotificationStatus = {};
      state.allSans = {};
      state.allSansRecordStatus = {};
      state.allSansRecord = [];
      state.addSansInSessionStatus = {};
      state.editSansInSessionStatus = {};
      state.deleteSessionSansStatus = {};
      state.getAllSansSubjectStatus = {};
      state.addNoticeForSansStatus = {};
      state.guestEnterStatus = {};
      state.userEnterStatus = {};
      state.userProfileData = {};
      state.editUserProfileStatus = {};
      state.editSessionStatus = {};
      state.audienceEntryData = {};
      state.allMeetGroup = {};
      state.deleteMeetGroupStatus = {};
      state.addNewMeetGroupStatus = {};
      state.profileChart = {};
      state.checkUrlStatus = {};
      state.financeCategoriesData = {};
      state.buyPlaneStatus = {};
      state.financeData = {};
      state.paymentList = {};
      state.organCreditList = {};
      state.allActiveSans = {};
      state.sansRecords = {};
      state.sansUser = {};
      state.userGroups = {};
      state.verificationStatus = null;
      state.tabStatus = 1;
      state.setIsGroupMeets = false;
      state.appTitle = "جلسات من";
    },
    checkTokenStatus(state, mainData) {
      state.tStatus = mainData;
    },
    setFirstEntry(state, mainData) {
      state.firstEntry = mainData;
    },
    setExpireUserId(state, mainData) {
      state.user.expire = mainData;
    },
    setSessionRout(state, mainData) {
      state.sessionRoute = mainData;
    },
    setNavNo(state, mainData) {
      state.navNo = mainData;
    },
    setSubNavNo(state, mainData) {
      state.subNavNo = mainData;
    },
    setPlanOrder(state, mainData) {
      state.plansOrder = mainData;
    },
    setNewInvoiceData(state, mainData) {
      state.newInvoiceData = mainData;
    },
    verificationStatus(state, mainData) {
      state.verificationStatus = mainData;
    },
    isShowNav(state, mainData) {
      state.isShowNavStatus = mainData;
    },
    setGroupEdited(state, mainData) {
      state.groupEdited = mainData;
    },
    setMeetGroupEdited(state, mainData) {
      state.meetGroupEdited = mainData;
    },
    setSessionStep1Data(state, mainData) {
      state.sessionStep1Data = mainData;
    },
    setDirectEntry(state, mainData) {
      state.setDirectEntryStatus = mainData;
    },
    setSessionStep2Data(state, mainData) {
      state.sessionStep2Data = mainData;
    },
    setIsGroupMeets(state, mainData) {
      state.setIsGroupMeets = mainData;
    },
    setAppTitle(state, mainData) {
      state.appTitle = mainData;
    },
    setOrganSelectForBuyPelan(state, mainData) {
      state.organSelectForBuyPelan = mainData;
    },
    setSessionStep3Data(state, mainData) {
      state.sessionStep3Data = mainData;
    },
    setTabStatus(state, mainData) {
      state.tabStatus = mainData;
    },
    setClickTabNav(state, mainData) {
      state.detailsTabIndex = mainData;
    },
    login(state, mainData) {
      state.user = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/login");
      data.append("username", mainData.mobile);
      data.append("captcha", mainData.captcha);
      data.append("session_url", mainData.session_url);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.user = response.data;
        })
        .catch();
    },
    directLogin(state, mainData) {
      state.user = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/login_by_token");
      data.append("token", mainData.token);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.user = response.data;
          state.isLoginWithPass = true;
        })
        .catch();
    },
    register(state, mainData) {
      state.register = {};
      state.changeMobile = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/register");
      data.append("first_name", mainData.first_name);
      data.append("last_name", mainData.last_name);
      data.append("email", "");
      data.append("gender", "");
      data.append("mobile", mainData.mobile);
      data.append("organ", mainData.org);
      data.append("password", mainData.password);
      data.append("captcha", mainData.captcha);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.register = response.data;
          state.changeMobile = {
            name: mainData.name,
            gender: "",
            mobile: mainData.mobile,
            org: mainData.org,
            password: mainData.password,
          };
        })
        .catch();
    },
    confirmCode(state, mainData) {
      state.userStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/confirm_code");
      data.append("user_id", mainData.user_id);
      data.append("code", mainData.code);
      data.append("session_url", mainData.session_url);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.isLoginWithPass = true;
          state.userStatus = response.data;
          state.user = response.data;
        })
        .catch();
    },
    directEntry(state, mainData) {
      state.directEntryStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/join_url");
      data.append("user_id", mainData.user_id);
      data.append("session_url", mainData.session_url);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.directEntryStatus = response.data;
        })
        .catch();
    },
    confirmGuestCode(state, mainData) {
      state.guestCodeStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/confirm_code_guest");
      data.append("code", mainData.code);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.guestCodeStatus = response.data;
        })
        .catch();
    },
    loginWithPass(state, mainData) {
      state.userprofile = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/password");
      data.append("user_id", mainData.user_id);
      data.append("password", mainData.password);
      data.append("session_url", mainData.session_url);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.userprofile = response.data;
          if (response.data.code == 100) {
            state.isLoginWithPass = true;
            state.user.permissions = response.data.permissions;
          } else {
            state.isLoginWithPass = false;
          }
        })
        .catch();
    },
    forgotPass(state, mainData) {
      state.forgotStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/recover_password");
      data.append("username", mainData.mobile);
      data.append("captcha", mainData.captcha);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.forgotStatus = response.data;
          state.user.user_id = response.data.user_id;
        })
        .catch();
    },
    setUserNewGroup(state, mainData) {
      state.userNewGroupStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/user_organ");
      data.append("user_id", mainData.user_id);
      data.append("organ", mainData.organ);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.userNewGroupStatus = response.data;
        })
        .catch();
    },
    addNewOrgan(state, mainData) {
      state.addNewOrganStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/organ");
      data.append("user_id", mainData.user_id);
      data.append("title", mainData.title);
      data.append("parent_id", mainData.parent_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addNewOrganStatus = response.data;
        })
        .catch();
    },
    editOrgan(state, mainData) {
      state.editOrganStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "edit/organ");
      data.append("user_id", mainData.user_id);
      data.append("title", mainData.title);
      data.append("parent_id", mainData.parent_id);
      data.append("organ_id", mainData.organ_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.editOrganStatus = response.data;
        })
        .catch();
    },
    deleteOrgan(state, mainData) {
      state.deleteOrganStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/organ");
      data.append("user_id", mainData.user_id);
      data.append("organ_id", mainData.organ_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteOrganStatus = response.data;
        })
        .catch();
    },
    setOrganUser(state, mainData) {
      state.setOrganUserStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "edit/user_organs");
      data.append("user_id", mainData.user_id);
      data.append("organ_ids", mainData.organ_ids);
      data.append("user_organ_id", mainData.user_organ_id);
      data.append("status", mainData.status);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.setOrganUserStatus = response.data;
        })
        .catch();
    },
    getReports(state, mainData) {
      state.getReportsStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/rollcall_report");
      data.append("user_id", mainData.user_id);
      data.append("organ_id", mainData.organ_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.getReportsStatus = response.data;
        })
        .catch();
    },
    getSansRecords(state, mainData) {
      state.getSansRecordsStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_sans_records");
      data.append("user_id", mainData.user_id);
      data.append("session_sans_id", mainData.session_sans_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.getSansRecordsStatus = response.data;
        })
        .catch();
    },
    setRecordingPolicy(state, mainData) {
      state.setRecordingPolicyStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/recording_policy");
      data.append("user_id", mainData.user_id);
      data.append("recording_id", mainData.recording_id);
      data.append("policy", mainData.policy);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.setRecordingPolicyStatus = response.data;
        })
        .catch();
    },
    setDiscount(state, mainData) {
      state.setDiscountStatus = {};
      state.setSissionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/voucher");
      data.append("user_id", mainData.user_id);
      data.append("temp_session_id", mainData.temp_session_id);
      data.append("voucher", mainData.voucher);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.setSissionStatus = response.data;
          state.setDiscountStatus = JSON.stringify(response.data);
        })
        .catch();
    },
    deleteTemp(state, mainData) {
      state.setDiscountStatus = {};
      state.setSissionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", mainData.type);
      data.append("user_id", mainData.user_id);
      data.append("temp_session_id", mainData.temp_session_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.setSissionStatus = response.data;
          state.setDiscountStatus = JSON.stringify(response.data);
        })
        .catch();
    },
    deleteTempSans(state, mainData) {
      state.setDiscountStatus = {};
      state.setSissionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/temp_session_sans");
      data.append("user_id", mainData.user_id);
      data.append("temp_session_sans_id", mainData.temp_session_sans_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.setSissionStatus = response.data;
          state.setDiscountStatus = JSON.stringify(response.data);
        })
        .catch();
    },
    getMyUsers(state, mainData) {
      state.allMyUser = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/user_list");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allMyUser = response.data;
        })
        .catch();
    },
    getAllUsersGroup(state, mainData) {
      state.allUserGroup = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/user_groups");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allUserGroup = response.data;
        })
        .catch();
    },
    getGroupUsers(state, mainData) {
      state.allGroupUser = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/user_group_users");
      data.append("user_group_id", mainData.user_group_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allGroupUser = response.data;
        })
        .catch();
    },
    getGroupMeets(state, mainData) {
      state.allGroupMeet = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_group_sessions");
      data.append("session_group_id", mainData.session_group_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allGroupMeet = response.data;
        })
        .catch();
    },
    setTitleGroup(state, mainData) {
      state.changeTitleStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "edit/user_group");
      data.append("title", mainData.title);
      data.append("user_group_id", mainData.user_group_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.changeTitleStatus = response.data;
        })
        .catch();
    },
    setTitleMeetGroup(state, mainData) {
      state.changeMeetGroupTitleStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "edit/session_group");
      data.append("title", mainData.title);
      data.append("session_group_id", mainData.session_group_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.changeMeetGroupTitleStatus = response.data;
        })
        .catch();
    },
    deleteUserInGroup(state, mainData) {
      state.deleteUserFromGroupStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/user_group_user");
      data.append("user_group_user_id", mainData.user_group_user_id);
      data.append("user_group_id", mainData.user_group_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteUserFromGroupStatus = response.data;
        })
        .catch();
    },
    deleteMeetInGroup(state, mainData) {
      state.deleteMeetInGroupStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/user_group_user");
      data.append("user_group_user_id", mainData.user_group_user_id);
      data.append("user_group_id", mainData.user_group_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteMeetInGroupStatus = response.data;
        })
        .catch();
    },
    addNewGroup(state, mainData) {
      state.addNewGroupStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/user_group");
      data.append("title", mainData.title);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addNewGroupStatus = response.data;
        })
        .catch();
    },
    deleteUserGroup(state, mainData) {
      state.deleteUserGroupStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/user_group");
      data.append("user_group_id", mainData.user_group_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteUserGroupStatus = response.data;
        })
        .catch();
    },
    deleteRecordSession(state, mainData) {
      state.deleteRecordSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/session_sans_recording");
      data.append("recording_id", mainData.recording_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteRecordSessionStatus = response.data;
        })
        .catch();
    },
    addUserSingle(state, mainData) {
      state.addUserSingleStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/user_group_user");
      data.append("mobile", mainData.mobile);
      data.append("first_name", mainData.first_name);
      data.append("last_name", mainData.last_name);
      data.append("email", mainData.email);
      data.append("user_group_id", mainData.user_group_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addUserSingleStatus = response.data;
        })
        .catch();
    },
    addUserSingleSession(state, mainData) {
      state.addUserSingleSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/session_user");
      data.append("role", mainData.role);
      data.append("mobile", mainData.mobile);
      data.append("first_name", mainData.first_name);
      data.append("last_name", mainData.last_name);
      data.append("email", mainData.email);
      data.append("session_id", mainData.session_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addUserSingleSessionStatus = response.data;
        })
        .catch();
    },
    addUserGroupSession(state, mainData) {
      state.addUserGroupSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/session_user_group");
      data.append("user_group_id", mainData.user_group_id);
      data.append("session_id", mainData.session_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addUserGroupSessionStatus = response.data;
        })
        .catch();
    },
    onlinePayment(state, mainData) {
      state.onlinePaymentStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/online_payment");
      data.append("amount", mainData.amount);
      data.append("organ_id", mainData.organ_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.onlinePaymentStatus = response.data;
        })
        .catch();
    },
    paymentBill(state, mainData) {
      state.paymentBillStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/payment_bill");
      data.append("bill", mainData.bill);
      data.append("organ_id", mainData.organ_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.paymentBillStatus = response.data;
        })
        .catch();
    },
    addSpecialSupport(state, mainData) {
      state.addSpecialSupportStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append(
        "type",
        mainData.isEdit ? "edit/support_request" : "set/support_request"
      );
      data.append("support_type", mainData.support_type);
      data.append("session_id", mainData.session_id);
      data.append("user_id", mainData.user_id);
      data.append("state", mainData.state);
      data.append("city", mainData.city);
      data.append("address", mainData.address);
      data.append("note", mainData.note);
      data.append("phone", mainData.phone);
      data.append("sans_id", mainData.sans_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addSpecialSupportStatus = response.data;
        })
        .catch();
    },
    addUserWithExcelSession(state, mainData) {
      state.addUserWithExcelSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/session_user_excel");
      data.append("excel", mainData.excel);
      data.append("session_id", mainData.session_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addUserWithExcelSessionStatus = response.data;
        })
        .catch();
    },
    addUserWithExcel(state, mainData) {
      state.addUserWithExcelStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/user_group_user_excel");
      data.append("excel", mainData.excel);
      data.append("user_group_id", mainData.user_group_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addUserWithExcelStatus = response.data;
        })
        .catch();
    },
    getAllSession(state, mainData) {
      state.getAllSessionData = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_list");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.getAllSessionData = response.data;
        })
        .catch();
    },
    getAllInvitedSession(state, mainData) {
      state.allInvitedSession = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/invited_session_list");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allInvitedSession = response.data;
        })
        .catch();
    },
    deleteSession(state, mainData) {
      state.deleteSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/session");
      data.append("session_id", mainData.session_id);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteSessionStatus = response.data;
        })
        .catch();
    },
    getAllSessionGroups(state, mainData) {
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_groups");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allSessionGroups = response.data;
        })
        .catch();
    },
    setSessionGroup(state, mainData) {
      state.setSessionGroupStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/session_group");
      data.append("title", mainData.title);
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.setSessionGroupStatus = response.data;
        })
        .catch();
    },
    getAllRole(state, mainData) {
      state.allRole = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/information");
      data.append("user_id", mainData.user_id);
      data.append("type_id", "15");
      data.append("parent_id", "0");
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allRole = response.data;
        })
        .catch();
    },
    getAllState(state, mainData) {
      state.allCities = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/information");
      data.append("user_id", mainData.user_id);
      data.append("type_id", mainData.type_id);
      data.append("parent_id", mainData.parent_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          if (mainData.parent_id == "0") {
            state.allState = response.data;
          } else {
            state.allCities = response.data;
          }
        })
        .catch();
    },
    getOrganization(state, mainData) {
      state.organization = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/information");
      data.append("user_id", mainData.user_id);
      data.append("type_id", "14");
      data.append("parent_id", "0");
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.organization = response.data;
        })
        .catch();
    },
    getAllTec(state, mainData) {
      state.allTec = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/information");
      data.append("user_id", mainData.user_id);
      data.append("type_id", "13");
      data.append("parent_id", "0");
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allTec = response.data;
        })
        .catch();
    },
    getAllType(state, mainData) {
      state.allType = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/information");
      data.append("user_id", mainData.user_id);
      data.append("type_id", "17");
      data.append("parent_id", "0");
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allType = response.data;
        })
        .catch();
    },
    getAllRecorStatus(state, mainData) {
      state.allStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/information");
      data.append("user_id", mainData.user_id);
      data.append("type_id", "19");
      data.append("parent_id", "0");
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allStatus = response.data;
        })
        .catch();
    },
    getUserWithExcelFile(state, mainData) {
      state.excelUser = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/user_group_user_excel");
      data.append("user_id", mainData.user_id);
      data.append("user_group_id", mainData.user_group_id);
      data.append("excel", mainData.excel);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.excelUser = response.data;
        })
        .catch();
    },
    getSessionInfo(state, mainData) {
      state.sessionInfo = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_info");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.sessionInfo = response.data;
        })
        .catch();
    },
    getSessionUsers(state, mainData) {
      state.sessionUsers = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_users");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.sessionUsers = response.data;
        })
        .catch();
    },
    getSessionNotifications(state, mainData) {
      state.sessionNotifications = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_notifications");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.sessionNotifications = response.data;
        })
        .catch();
    },
    getSpecialSupport(state, mainData) {
      state.specialSupportData = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/support_request");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.specialSupportData = response.data;
        })
        .catch();
    },
    deletespecialSupport(state, mainData) {
      state.deletespecialSupportStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/support_request");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      data.append("support_id", mainData.support_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deletespecialSupportStatus = response.data;
        })
        .catch();
    },
    editUserInSession(state, mainData) {
      state.editUserInSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "edit/session_user");
      data.append("user_id", mainData.user_id);
      data.append("session_user_id", mainData.session_user_id);
      data.append("mobile", mainData.mobile);
      data.append("first_name", mainData.first_name);
      data.append("last_name", mainData.last_name);
      data.append("email", mainData.email);
      data.append("role", mainData.role);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.editUserInSessionStatus = response.data;
        })
        .catch();
    },
    deleteUserOfSession(state, mainData) {
      state.deleteUserOfSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/session_user");
      data.append("user_id", mainData.user_id);
      data.append("session_user_id", mainData.session_user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteUserOfSessionStatus = response.data;
        })
        .catch();
    },
    checkUrl(state, mainData) {
      state.checkUrlStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/session_url");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      data.append("url", mainData.url);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.checkUrlStatus = response.data;
        })
        .catch();
    },
    deleteSessionNotification(state, mainData) {
      state.deleteSessionNotificationStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/notification");
      data.append("user_id", mainData.user_id);
      data.append("notification_id", mainData.notification_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteSessionNotificationStatus = response.data;
        })
        .catch();
    },
    getAllSans(state, mainData) {
      state.allSans = {};
      state.allSansRecord = {};
      state.allSansRecordStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_sans");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allSans = response.data;
          if (mainData.record) {
            state.allSansRecordStatus = response.data;
            state.allSansRecord = response.data.session_sanses;
            state.sessionForRecord = mainData.el;
          }
        })
        .catch();
    },
    getAllActiveSans(state, mainData) {
      state.allActiveSans = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_sans");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      data.append("sans_status", "active,held_wait");
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allActiveSans = response.data;
        })
        .catch();
    },
    addSansInSession(state, mainData) {
      state.addSansInSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/session_sans");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      data.append("title", mainData.title);
      data.append("date_from", mainData.date_from);
      data.append("time_from", mainData.time_from);
      data.append("date_to", mainData.date_to);
      data.append("time_to", mainData.time_to);
      data.append("days", mainData.days);
      data.append("gender", "");
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addSansInSessionStatus = response.data;
        })
        .catch();
    },
    editSansInSession(state, mainData) {
      state.editSansInSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "edit/session_sans");
      data.append("user_id", mainData.user_id);
      data.append("session_sans_id", mainData.session_sans_id);
      data.append("title", mainData.title);
      data.append("date_from", mainData.date_from);
      data.append("time_from", mainData.time_from);
      data.append("date_to", mainData.date_to);
      data.append("time_to", mainData.time_to);
      data.append("gender", "");
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.editSansInSessionStatus = response.data;
        })
        .catch();
    },
    deleteSessionSans(state, mainData) {
      state.deleteSessionSansStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/session_sans");
      data.append("user_id", mainData.user_id);
      data.append("session_sans_id", mainData.session_sans_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteSessionSansStatus = response.data;
        })
        .catch();
    },
    getAllSansSubject(state, mainData) {
      state.getAllSansSubjectStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/notification_subjects");
      data.append("user_id", mainData.user_id);
      data.append("sans_id", mainData.sans_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.getAllSansSubjectStatus = response.data;
        })
        .catch();
    },
    setVoucher(state, mainData) {
      state.voucherData = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/voucher");
      data.append("user_id", mainData.user_id);
      data.append("transaction_id", mainData.transaction_id);
      data.append("voucher", mainData.voucher);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.voucherData = response.data;
        })
        .catch();
    },
    getOrganPackagesPlansList(state, mainData) {
      state.packagesPlansList = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/organ_package_plan_list");
      data.append("user_id", mainData.user_id);
      data.append("organ_id", mainData.organ_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.packagesPlansList = response.data;
        })
        .catch();
    },
    getAllPlans(state, mainData) {
      state.allPlans = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/subscription_plans_list");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allPlans = response.data;
        })
        .catch();
    },
    getAllPackage(state, mainData) {
      state.allPackage = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/subscription_package_list");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allPackage = response.data;
        })
        .catch();
    },
    getPlanTansaction(state, mainData) {
      state.planTansaction = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/transaction_info");
      data.append("user_id", mainData.user_id);
      data.append("transaction_id", mainData.transaction_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.planTansaction = response.data;
        })
        .catch();
    },
    finalPaymentPelan(state, mainData) {
      state.buyResult = {};
      var FormData = require("form-data");
      var data = new FormData();
      Object.keys(mainData).forEach((key) => {
        data.append(key, mainData[key]);
      });
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.buyResult = response.data;
        })
        .catch();
    },
    finalPaymentPackages(state, mainData) {
      state.buyPackagesResult = {};
      var FormData = require("form-data");
      var data = new FormData();
      Object.keys(mainData).forEach((key) => {
        data.append(key, mainData[key]);
      });
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.buyPackagesResult = response.data;
        })
        .catch();
    },
    addNoticeForSans(state, mainData) {
      state.addNoticeForSansStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/notification");
      data.append("user_id", mainData.user_id);
      data.append("sans_id", mainData.sans_id);
      data.append("subject_id", mainData.subject_id);
      data.append("send_type", mainData.send_type);
      data.append("content", mainData.content);
      data.append("send_date", mainData.send_date);
      data.append("send_time", mainData.send_time);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addNoticeForSansStatus = response.data;
        })
        .catch();
    },
    getUserProfile(state, mainData) {
      state.userProfileData = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/profile");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.userProfileData = response.data;
        })
        .catch();
    },
    editUserProfile(state, mainData) {
      state.editUserProfileStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "edit/profile");
      data.append("user_id", mainData.user_id);
      data.append("first_name", mainData.first_name);
      data.append("last_name", mainData.last_name);
      data.append("email", "");
      data.append("gender", "");
      data.append("mobile", mainData.mobile);
      data.append("password", mainData.password);
      data.append("avatar", mainData.avatar);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.editUserProfileStatus = response.data;
        })
        .catch();
    },
    editSession(state, mainData) {
      state.editSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "edit/session");
      data.append("user_id", mainData.user_id);
      data.append("session_id", mainData.session_id);
      data.append("organ_id", mainData.organ_id);
      data.append("title", mainData.title);
      data.append("group_id", mainData.group_id);
      data.append("total_capacity", mainData.total_capacity);
      data.append("guest_policy", mainData.guest_policy);
      data.append("technology", mainData.technology);
      data.append("record", mainData.record);
      data.append("landing_url", mainData.landing_url);
      data.append("logo", mainData.logo);
      data.append("banner", mainData.banner);
      data.append("status", mainData.status);
      data.append("note", mainData.note);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.editSessionStatus = response.data;
        })
        .catch();
    },
    getAudienceEntryData(state, mainData) {
      state.audienceEntryData = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_by_url");
      data.append("url", mainData.url);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.audienceEntryData = response.data;
        })
        .catch();
    },
    guestEnter(state, mainData) {
      state.guestEnterStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/guest_login");
      data.append("user_id", mainData.user_id);
      data.append("url", mainData.url);
      data.append("name", mainData.name);
      data.append("mobile", mainData.mobile);
      data.append("email", "");
      data.append("captcha", mainData.captcha);
      data.append("gender", "");
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.guestEnterStatus = response.data;
        })
        .catch();
    },
    getAllMeetGroup(state, mainData) {
      state.allMeetGroup = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_groups");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allMeetGroup = response.data;
        })
        .catch();
    },
    sessionPhotoDelete(state, mainData) {
      state.sessionPhotoDeleteStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/multimedia");
      data.append("user_id", mainData.user_id);
      data.append("section", mainData.section);
      data.append("section_id", mainData.section_id);
      data.append("subject", mainData.subject);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.sessionPhotoDeleteStatus = response.data;
        })
        .catch();
    },
    deleteMeetGroup(state, mainData) {
      state.deleteMeetGroupStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "del/session_group");
      data.append("user_id", mainData.user_id);
      data.append("session_group_id", mainData.session_group_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.deleteMeetGroupStatus = response.data;
        })
        .catch();
    },
    addNewMeetGroup(state, mainData) {
      state.addNewMeetGroupStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/session_group");
      data.append("user_id", mainData.user_id);
      data.append("title", mainData.title);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.addNewMeetGroupStatus = response.data;
        })
        .catch();
    },
    getFinanceCategories(state, mainData) {
      state.financeCategoriesData = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/plans");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.financeCategoriesData = response.data;
        })
        .catch();
    },
    buyPlane(state, mainData) {
      state.buyPlaneStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/plans");
      data.append("user_id", mainData.user_id);
      data.append("plan_id", mainData.plan_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.buyPlaneStatus = response.data;
        })
        .catch();
    },
    getAllFinanceData(state, mainData) {
      state.financeData = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/finance_data");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.financeData = response.data;
        })
        .catch();
    },
    getPaymentList(state, mainData) {
      state.paymentList = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/information");
      data.append("user_id", mainData.user_id);
      data.append("type_id", 21);
      data.append("parent_id", 0);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.paymentList = response.data;
        })
        .catch();
    },
    getOrganCreditList(state, mainData) {
      state.organCreditList = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/organ_credit_list");
      data.append("user_id", mainData.user_id);
      data.append("organ_id", mainData.organ_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.organCreditList = response.data;
        })
        .catch();
    },
    getProfileChart(state, mainData) {
      state.profileChart = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/charts");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.profileChart = response.data;
        })
        .catch();
    },
    getAllSansRecord(state, mainData) {
      state.sansRecords = {};
      var FormData = require("form-data");
      var data = new FormData();
      if (mainData.routType == "mySession") {
        data.append("type", "get/session_sans_records");
      } else {
        data.append("type", "get/invited_session_sans_records");
      }
      data.append("user_id", mainData.user_id);
      data.append("session_sans_id", mainData.session_sans_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.sansRecords = response.data;
        })
        .catch();
    },
    getAllUserOrg(state, mainData) {
      state.allUserOrg = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/organ_list");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allUserOrg = response.data;
        })
        .catch();
    },
    getSansUser(state, mainData) {
      state.sansUser = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/session_sans_attendees");
      data.append("user_id", mainData.user_id);
      data.append("session_sans_id", mainData.session_sans_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.sansUser = response.data;
        })
        .catch();
    },
    getUserGroups(state, mainData) {
      state.userGroups = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/user_organs");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.userGroups = response.data;
        })
        .catch();
    },
    getAllOrganList(state, mainData) {
      state.allOrganList = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/organ_list");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allOrganList = response.data;
        })
        .catch();
    },
    getAllParentOrganList(state, mainData) {
      state.allParentOrganList = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "get/parent_organ_list");
      data.append("user_id", mainData.user_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.allParentOrganList = response.data;
        })
        .catch();
    },
    userEnter(state, mainData) {
      state.userEnterStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/login");
      data.append("username", mainData.mobile);
      data.append("session_url", mainData.url);
      data.append("captcha", mainData.captcha);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.userEnterStatus = response.data;
        })
        .catch();
    },
    createSession(state, mainData) {
      state.createSessionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/session");
      data.append("user_id", mainData.user_id);
      data.append("temp_session_id", mainData.temp_session_id);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.createSessionStatus = response.data;
        })
        .catch();
    },
    setSission(state, mainData) {
      state.setSissionStatus = {};
      var FormData = require("form-data");
      var data = new FormData();
      data.append("type", "set/session_new");
      data.append("user_id", mainData.user_id);
      data.append("users", mainData.users);
      data.append("title", mainData.title);
      data.append("group_id", mainData.group_id);
      data.append("organ_id", mainData.organ_id);
      data.append("total_capacity", mainData.total_capacity);
      data.append("guest_policy", mainData.guest_policy);
      data.append("guest_capacity", mainData.guest_capacity);
      data.append("technology", mainData.technology);
      data.append("record", mainData.record);
      data.append("date_from", mainData.date_from);
      data.append("time_from", mainData.time_from);
      data.append("date_to", mainData.date_to);
      data.append("time_to", mainData.time_to);
      data.append("repeat_period", mainData.repeat_period);
      data.append("days", mainData.days);
      data.append("landing_template", mainData.landing_template);
      data.append("landing_url", mainData.landing_url);
      data.append("logo", mainData.logo);
      data.append("banner", mainData.banner);
      data.append("note", mainData.note);
      data.append("support_type", mainData.support_type);
      data.append("support_state", mainData.support_state);
      data.append("support_city", mainData.support_city);
      data.append("support_address", mainData.support_address);
      data.append("support_phone", mainData.support_phone);
      data.append("note", mainData.note);
      HTTP.post(Url.http + "://" + Url.domainName, data)
        .then((response) => {
          state.setSissionStatus = response.data;
        })
        .catch();
    },
  },
  actions: {
    setNavNoFunction({ commit }, data) {
      commit("setNavNo", data);
    },
    setSubNavNoFunction({ commit }, data) {
      commit("setSubNavNo", data);
    },
    exitFunction({ commit }) {
      commit("exit");
    },
    loginFunction({ commit }, data) {
      commit("login", data);
    },
    registerFunction({ commit }, data) {
      commit("register", data);
    },
    confirmCodeFunction({ commit }, data) {
      commit("confirmCode", data);
    },
    directEntryFunction({ commit }, data) {
      commit("directEntry", data);
    },
    confirmGuestCodeFunction({ commit }, data) {
      commit("confirmGuestCode", data);
    },
    loginWithPassFunction({ commit }, data) {
      commit("loginWithPass", data);
    },
    forgotPassFunction({ commit }, data) {
      commit("forgotPass", data);
    },
    verificationStatusFunction({ commit }, data) {
      commit("verificationStatus", data);
    },
    getMyUsersFunction({ commit }, data) {
      commit("getMyUsers", data);
    },
    getAllUsersGroupFunction({ commit }, data) {
      commit("getAllUsersGroup", data);
    },
    setGroupEditedFunction({ commit }, data) {
      commit("setGroupEdited", data);
    },
    getGroupUsersFunction({ commit }, data) {
      commit("getGroupUsers", data);
    },
    getGroupMeetsFunction({ commit }, data) {
      commit("getGroupMeets", data);
    },
    setTitleGroupFunction({ commit }, data) {
      commit("setTitleGroup", data);
    },
    setTitleMeetGroupFunction({ commit }, data) {
      commit("setTitleMeetGroup", data);
    },
    deleteUserInGroupFunction({ commit }, data) {
      commit("deleteUserInGroup", data);
    },
    deleteMeetInGroupFunction({ commit }, data) {
      commit("deleteMeetInGroup", data);
    },
    addNewGroupFunction({ commit }, data) {
      commit("addNewGroup", data);
    },
    deleteUserGroupFunction({ commit }, data) {
      commit("deleteUserGroup", data);
    },
    addUserSingleFunction({ commit }, data) {
      commit("addUserSingle", data);
    },
    addUserSingleSessionFunction({ commit }, data) {
      commit("addUserSingleSession", data);
    },
    addUserGroupSessionFunction({ commit }, data) {
      commit("addUserGroupSession", data);
    },
    addUserWithExcelSessionFunction({ commit }, data) {
      commit("addUserWithExcelSession", data);
    },
    addUserWithExcelFunction({ commit }, data) {
      commit("addUserWithExcel", data);
    },
    getAllSessionFunction({ commit }, data) {
      commit("getAllSession", data);
    },
    getAllInvitedSessionFunction({ commit }, data) {
      commit("getAllInvitedSession", data);
    },
    deleteSessionFunction({ commit }, data) {
      commit("deleteSession", data);
    },
    getAllSessionGroupsFunction({ commit }, data) {
      commit("getAllSessionGroups", data);
    },
    setSessionGroupFunction({ commit }, data) {
      commit("setSessionGroup", data);
    },
    setSessionStep1DataFunction({ commit }, data) {
      commit("setSessionStep1Data", data);
    },
    setDirectEntryFunction({ commit }, data) {
      commit("setDirectEntry", data);
    },
    setSessionStep2DataFunction({ commit }, data) {
      commit("setSessionStep2Data", data);
    },
    setSessionStep3DataFunction({ commit }, data) {
      commit("setSessionStep3Data", data);
    },
    getAllRoleFunction({ commit }, data) {
      commit("getAllRole", data);
    },
    getAllStateFunction({ commit }, data) {
      commit("getAllState", data);
    },
    getAllTecFunction({ commit }, data) {
      commit("getAllTec", data);
    },
    getAllTypeFunction({ commit }, data) {
      commit("getAllType", data);
    },
    getAllRecorStatusFunction({ commit }, data) {
      commit("getAllRecorStatus", data);
    },
    getUserWithExcelFileFunction({ commit }, data) {
      commit("getUserWithExcelFile", data);
    },
    setSissionFunction({ commit }, data) {
      commit("setSission", data);
    },
    createSessionFunction({ commit }, data) {
      commit("createSession", data);
    },
    getSessionInfoFunction({ commit }, data) {
      commit("getSessionInfo", data);
    },
    getSessionUsersFunction({ commit }, data) {
      commit("getSessionUsers", data);
    },
    getSessionNotificationsFunction({ commit }, data) {
      commit("getSessionNotifications", data);
    },
    getSpecialSupportFunction({ commit }, data) {
      commit("getSpecialSupport", data);
    },
    deletespecialSupportFunction({ commit }, data) {
      commit("deletespecialSupport", data);
    },
    editUserInSessionFunction({ commit }, data) {
      commit("editUserInSession", data);
    },
    deleteUserOfSessionFunction({ commit }, data) {
      commit("deleteUserOfSession", data);
    },
    deleteSessionNotificationFunction({ commit }, data) {
      commit("deleteSessionNotification", data);
    },
    getAllSansFunction({ commit }, data) {
      commit("getAllSans", data);
    },
    getAllActiveSansFunction({ commit }, data) {
      commit("getAllActiveSans", data);
    },
    addSansInSessionFunction({ commit }, data) {
      commit("addSansInSession", data);
    },
    editSansInSessionFunction({ commit }, data) {
      commit("editSansInSession", data);
    },
    deleteSessionSansFunction({ commit }, data) {
      commit("deleteSessionSans", data);
    },
    getAllSansSubjectFunction({ commit }, data) {
      commit("getAllSansSubject", data);
    },
    addNoticeForSansFunction({ commit }, data) {
      commit("addNoticeForSans", data);
    },
    guestEnterFunction({ commit }, data) {
      commit("guestEnter", data);
    },
    userEnterFunction({ commit }, data) {
      commit("userEnter", data);
    },
    getUserProfileFunction({ commit }, data) {
      commit("getUserProfile", data);
    },
    editUserProfileFunction({ commit }, data) {
      commit("editUserProfile", data);
    },
    editSessionFunction({ commit }, data) {
      commit("editSession", data);
    },
    getAudienceEntryDataFunction({ commit }, data) {
      commit("getAudienceEntryData", data);
    },
    setTabStatusFunction({ commit }, data) {
      commit("setTabStatus", data);
    },
    setClickTabNavFunction({ commit }, data) {
      commit("setClickTabNav", data);
    },
    getAllMeetGroupFunction({ commit }, data) {
      commit("getAllMeetGroup", data);
    },
    deleteMeetGroupFunction({ commit }, data) {
      commit("deleteMeetGroup", data);
    },
    addNewMeetGroupFunction({ commit }, data) {
      commit("addNewMeetGroup", data);
    },
    setMeetGroupEditedFunction({ commit }, data) {
      commit("setMeetGroupEdited", data);
    },
    setIsGroupMeetsFunction({ commit }, data) {
      commit("setIsGroupMeets", data);
    },
    checkUrlFunction({ commit }, data) {
      commit("checkUrl", data);
    },
    setAppTitleFunction({ commit }, data) {
      commit("setAppTitle", data);
    },
    getProfileChartFunction({ commit }, data) {
      commit("getProfileChart", data);
    },
    getFinanceCategoriesFunction({ commit }, data) {
      commit("getFinanceCategories", data);
    },
    buyPlaneFunction({ commit }, data) {
      commit("buyPlane", data);
    },
    getAllFinanceDataFunction({ commit }, data) {
      commit("getAllFinanceData", data);
    },
    isShowNavFunction({ commit }, data) {
      commit("isShowNav", data);
    },
    getOrganizationFunction({ commit }, data) {
      commit("getOrganization", data);
    },
    getAllSansRecordFunction({ commit }, data) {
      commit("getAllSansRecord", data);
    },
    getAllUserOrgFunction({ commit }, data) {
      commit("getAllUserOrg", data);
    },
    getSansUserFunction({ commit }, data) {
      commit("getSansUser", data);
    },
    getUserGroupsFunction({ commit }, data) {
      commit("getUserGroups", data);
    },
    getAllOrganListFunction({ commit }, data) {
      commit("getAllOrganList", data);
    },
    getAllParentOrganListFunction({ commit }, data) {
      commit("getAllParentOrganList", data);
    },
    sessionPhotoDeleteFunction({ commit }, data) {
      commit("sessionPhotoDelete", data);
    },
    setExpireUserIdFunction({ commit }, data) {
      commit("setExpireUserId", data);
    },
    setSessionRoutFunction({ commit }, data) {
      commit("setSessionRout", data);
    },
    addSpecialSupportFunction({ commit }, data) {
      commit("addSpecialSupport", data);
    },
    setUserNewGroupFunction({ commit }, data) {
      commit("setUserNewGroup", data);
    },
    addNewOrganFunction({ commit }, data) {
      commit("addNewOrgan", data);
    },
    editOrganFunction({ commit }, data) {
      commit("editOrgan", data);
    },
    deleteOrganFunction({ commit }, data) {
      commit("deleteOrgan", data);
    },
    setOrganUserFunction({ commit }, data) {
      commit("setOrganUser", data);
    },
    getReportsFunction({ commit }, data) {
      commit("getReports", data);
    },
    getSansRecordsFunction({ commit }, data) {
      commit("getSansRecords", data);
    },
    setRecordingPolicyFunction({ commit }, data) {
      commit("setRecordingPolicy", data);
    },
    setDiscountFunction({ commit }, data) {
      commit("setDiscount", data);
    },
    deleteTempFunction({ commit }, data) {
      commit("deleteTemp", data);
    },
    deleteTempSansFunction({ commit }, data) {
      commit("deleteTempSans", data);
    },
    setNewInvoiceDataFunction({ commit }, data) {
      commit("setNewInvoiceData", data);
    },
    directLoginFunction({ commit }, data) {
      commit("directLogin", data);
    },
    getPaymentListFunction({ commit }, data) {
      commit("getPaymentList", data);
    },
    getOrganCreditListFunction({ commit }, data) {
      commit("getOrganCreditList", data);
    },
    deleteRecordSessionFunction({ commit }, data) {
      commit("deleteRecordSession", data);
    },
    onlinePaymentFunction({ commit }, data) {
      commit("onlinePayment", data);
    },
    paymentBillFunction({ commit }, data) {
      commit("paymentBill", data);
    },
    setPlanOrderFunction({ commit }, data) {
      commit("setPlanOrder", data);
    },
    setFirstEntryFunction({ commit }, data) {
      commit("setFirstEntry", data);
    },
    getOrganPackagesPlansListFunction({ commit }, data) {
      commit("getOrganPackagesPlansList", data);
    },
    getAllPlansFunction({ commit }, data) {
      commit("getAllPlans", data);
    },
    getAllPackageFunction({ commit }, data) {
      commit("getAllPackage", data);
    },
    finalPaymentPelanFunction({ commit }, data) {
      commit("finalPaymentPelan", data);
    },
    finalPaymentPackagesFunction({ commit }, data) {
      commit("finalPaymentPackages", data);
    },
    setOrganSelectForBuyPelanFunction({ commit }, data) {
      commit("setOrganSelectForBuyPelan", data);
    },
    getPlanTansactionFunction({ commit }, data) {
      commit("getPlanTansaction", data);
    },
    setVoucherFunction({ commit }, data) {
      commit("setVoucher", data);
    },
    checkTokenStatusFunction({ commit }, data) {
      commit("checkTokenStatus", data);
    },
  },
  getters: {},
};
